import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { StarIcon as StarIconSolid } from '@heroicons/react/24/solid';
import { StarIcon as StarIconOutline } from '@heroicons/react/24/outline';
import io from 'socket.io-client';

const Feedbacks = () => {
  const [feedbacks, setFeedbacks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Charger les produits et les feedbacks
    fetchProducts();

    // Connexion Socket.IO pour les mises à jour en temps réel
    const socket = io(process.env.REACT_APP_API_URL);

    socket.on('new_feedback', (feedback) => {
      setFeedbacks(prev => [...prev, feedback]);
    });

    socket.on('feedback_updated', (updatedFeedback) => {
      setFeedbacks(prev => prev.map(f => 
        f.id === updatedFeedback.id ? updatedFeedback : f
      ));
    });

    return () => socket.disconnect();
  }, []);

  const fetchProducts = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/products`);
      const productsData = await response.json();
      
      // Extraire tous les feedbacks des produits
      const allFeedbacks = productsData.reduce((acc, product) => {
        if (product.feedbacks) {
          return [...acc, ...product.feedbacks.map(f => ({
            ...f,
            productTitle: product.title,
            productId: product.id,
            productCustomUrl: product.customUrl
          }))];
        }
        return acc;
      }, []);

      // Trier les feedbacks par date (plus récent en premier)
      allFeedbacks.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      setFeedbacks(allFeedbacks);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching data:', error);
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-8 text-center">Customer Reviews</h1>
      
      <div className="grid gap-6">
        {feedbacks.map((feedback, index) => (
          <div key={index} className="glass-card p-6">
            <div className="flex justify-between items-start">
              <div>
                <Link 
                  to={feedback.productCustomUrl ? `/${feedback.productCustomUrl}` : `/product/${feedback.productId}`}
                  className="text-lg font-medium feature-text hover:text-[#15803d] transition-colors"
                >
                  {feedback.productTitle}
                </Link>
                <div className="flex items-center space-x-2 mt-2">
                  <div className="flex">
                    {[1, 2, 3, 4, 5].map((star) => (
                      star <= feedback.rating ? (
                        <StarIconSolid key={star} className="h-5 w-5 review-star filled" />
                      ) : (
                        <StarIconOutline key={star} className="h-5 w-5 review-star" />
                      )
                    ))}
                  </div>
                  <span className="text-sm text-gray-400">
                    {new Date(feedback.createdAt).toLocaleDateString()}
                  </span>
                </div>
              </div>
            </div>
            
            <p className="mt-4 text-gray-300">{feedback.message}</p>
            {feedback.reply && (
              <div className="mt-2 pl-4 border-l-2 border-primary">
                <p className="text-sm text-gray-400">Admin Reply:</p>
                <p className="text-sm text-gray-300">{feedback.reply}</p>
              </div>
            )}
          </div>
        ))}

        {feedbacks.length === 0 && (
          <div className="glass-card p-12 text-center">
            <p className="text-xl text-gray-400">No reviews yet</p>
            <p className="text-gray-500 mt-2">Be the first to leave a review!</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Feedbacks; 